import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../styles/game/InfoBoard.css';
import '../../styles/game/InfoBoardTabs.css';
import '../../styles/game/InfoBoardComponents.css';
import { t } from "i18next";
import { useData, useSocket } from '../../providers/SocketContext.jsx'
import { useAuth } from '../../providers/AuthProvider.jsx';

function RealTimeBetsComponent({RealTimeBets, mainWallet}) {
    const { user } = useAuth()
    const socket = useSocket()
    const [allBets, setAllBets] = useState({})
    useEffect(() => {
        if (!socket) return;
    
        const handleAllBetsList = (res, sendBets) => {
          const sendBetsArr = []
          for (const bet in sendBets) {
            sendBetsArr.push(sendBets[bet])
          }
          const combinedBets = [...res, ...sendBetsArr]
          combinedBets.sort((a, b) => parseFloat(b.bet) - parseFloat(a.bet));
          // const sortedBets = sortByBetAscending(combinedBets)
          // console.log("Received bets:", sortedBets);
          setAllBets(combinedBets);
        };
    
        socket.on("allBetsList", handleAllBetsList);
    
        // Удаляем обработчик при размонтировании
        return () => {
          socket.off("allBetsList", handleAllBetsList);
        };
      }, [socket]);






      useEffect(() => {
        if(!socket) {
          return
        }
        const handleAllBetsList = (res, sendBets) => {
          const sendBetsArr = []
          for (const bet in sendBets) {
            sendBetsArr.push(sendBets[bet])
          }
          const combinedBets = [...res, ...sendBetsArr]
  
          // const sortedBets = sortByBetAscending(combinedBets)
          combinedBets.sort((a, b) => parseFloat(b.bet) - parseFloat(a.bet));
          // console.log("Received bets:", sortedBets);
          setAllBets(combinedBets);
        };
  
        socket.emit('connectAllbets')
        socket.on('connectAllbets_res', handleAllBetsList)
        
        return () => {
          socket.off("connectAllbets_res");
          socket.off('connectAllbets')
        };
  
      }, [socket])








      useEffect(() => {
        if(!socket) {
          return
        }

        socket.on('countdown', (countdown) => {
          // const sortedData = sortByBetAscending(sendBets)
          // console.log(sortedData)
        })

        return () => {
          socket.off('countdown')
        }
      }, [socket])

      useEffect(() => {
        if (!socket) return;
      
        socket.on('allBets_cashout', (res) => {
          
          // setAllBets((prevState) => {
          //   // Создаем новый объект, чтобы React увидел изменения
          //   return {
          //     ...prevState,
          //     [res.socketId]: {
          //       ...prevState[res.socketId], // Сохраняем старые данные, если они есть
          //       ...res, // Обновляем только переданные данные
          //     },
          //   };
          // });
          setAllBets((prevState) => 
          prevState.map((obj) => 
            obj.socketId === res.socketId && obj.hand === res.hand 
              ? { ...obj, ...res } // Обновляем найденный объект новыми данными из res
              : obj // Неизмененные объекты возвращаем как есть
          )
        );
        });
      
        return () => {
          socket.off('allBets_cashout');
        };
      }, [socket]);



      function AnotherBets({bet, aviatorId, avatarUrl, cashout, profit, mainWallet}) {
        const {resultData} = useData()
        const [isData, setIsData] = useState(0)
        const [isCashout, setIsCashout] = useState(false)
        const [color, setColor] = useState("rgb(52, 180, 255)");
        const [currencyRate, setCurrencyRate] = useState(null)
        useEffect(() => {
          if(mainWallet) {
            if(mainWallet === 'uzs') {
              setCurrencyRate(13000)
            } else if (mainWallet === 'usd') {
              setCurrencyRate(1)
            } else if (mainWallet === 'rub') {
              setCurrencyRate(100)
            } else {
              setCurrencyRate(1)
            }
            
          }
        }, [mainWallet])
        
        useEffect(() => {
          const parseResultData = parseFloat(resultData)
          const parseCashout = parseFloat(cashout)
          
          if (parseCashout >= 2.00 && parseCashout < 10.00) {
            setColor("rgb(145, 62, 248)")
          } else if (parseCashout >= 10.00) {
            setColor("rgb(192, 23, 180)")
          }
            
          if(parseResultData >= parseCashout) {
              setIsCashout(true)
            
          }
          
        }, [resultData])
  

  
        // useEffect(() => {
  
  
  
  
        //   if (!socket) {
        //     return
        //   }
  
        //   socket.on('data', (res) => {
        //     setIsData(res.value);
        //   })
  
        //   const parseResultData = parseFloat(isData)
        //   const parseCashout = parseFloat(cashout)
  
        //   if(parseResultData >= parseCashout) {
        //     setIsCashout(true)
        //   }
  
        //   return () => {
        //     socket.off('data')
        // }
  
        // }, [socket])
  
  
  
        return (
        <>
        <div className={`my-bet-item-wrap new ${isCashout ? "celebrated" : ""}`}>
            <div className={'all-bets-user-wrap'}>
                <img src={avatarUrl} alt="" />
                <div>{aviatorId ? aviatorId : ""}</div>
            </div>
            <div className={'my-bet-item-bet new'}>
                <div>    {bet
          ? new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(bet * currencyRate)
          : ""}</div>
            </div>
            <div className={'my-bet-item-multiplier new'}>
                <div>
                    {isCashout && <div style={{color}} className={`bubble-multiplier new`}>{cashout ? parseFloat(cashout).toFixed(2) + "x" : ""}</div>}
                </div>
            </div>
            <div className={'my-bet-item-cash-out new'}>
                {isCashout ? <div>{new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(profit * currencyRate)}</div> : ""}
            </div>
        </div>
    </>
    )
      }



          function RealTimeBets({bet, celebrated, aviatorId, avatarUrl, cashout, profit, mainWallet}) {
      const [color, setColor] = useState("rgb(52, 180, 255)");

      useEffect(() => {
        const parseCashout = parseFloat(cashout)
        
        if (parseCashout >= 2.00 && parseCashout < 10.00) {
          setColor("rgb(145, 62, 248)")
        } else if (parseCashout >= 10.00) {
          setColor("rgb(192, 23, 180)")
        }
    
        
      }, [cashout])

        return (
            <>
                <div className={`my-bet-item-wrap new ${cashout ? "celebrated" : ""}`}>
                    <div className={'all-bets-user-wrap'}>
                        <img src={avatarUrl} alt="" />
                        <div>{aviatorId ? `${aviatorId[0]}***${aviatorId[7]}` : ""}</div>
                    </div>
                    <div className={'my-bet-item-bet new'}>
                        <div>{bet ? bet : ""}</div>
                    </div>
                    <div className={'my-bet-item-multiplier new'}>
                        <div>
                            {cashout && <div style={{color}} className={`bubble-multiplier new`}>{cashout ? parseFloat(cashout).toFixed(2) + "x" : ""}</div>}
                        </div>
                    </div>
                    <div className={'my-bet-item-cash-out new'}>
                        {cashout ? <div>{parseFloat(profit).toFixed(2)}</div> : ""}
                    </div>
                </div>
            </>
        )
    }




    return (
        <div className={'real-time-bets-wrapper'}>
        <div className={'real-time-bets-container'}>
{/* Проверка на пустой объект */}
{Object.keys(allBets).length > 0 ? (
<>
  {Object.entries(allBets).slice(0, 50).map(([key, bet]) => (
bet.hasOwnProperty('another') ? (
<AnotherBets
key={key}
bet={bet.bet}
avatarUrl={bet.avatarUrl}
aviatorId={bet.aviatorId}
cashout={bet.cashout}
profit={bet.profit}
mainWallet={mainWallet}
/>
) : (
<>
  {/* <RealTimeBets
key={key}
bet={bet.bet}
avatarUrl={bet.avatarUrl}
aviatorId={bet.aviatorId}
cashout={bet.cashout}
profit={bet.profit}
mainWallet={mainWallet}
/> */}
</>

)
))}
</>
) : (
""
)}


        </div>
    </div>
    )
}

export default RealTimeBetsComponent;